import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGeneralCargo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30 54.9998V29.9998M30 29.9998L8.225 17.4998M30 29.9998L51.775 17.4998M18.75 10.6748L41.25 23.5498M27.5 54.3248C28.2601 54.7636 29.1223 54.9946 30 54.9946C30.8777 54.9946 31.7399 54.7636 32.5 54.3248L50 44.3248C50.7593 43.8863 51.3901 43.256 51.8288 42.4968C52.2676 41.7377 52.4991 40.8766 52.5 39.9998V19.9998C52.4991 19.1229 52.2676 18.2618 51.8288 17.5027C51.3901 16.7435 50.7593 16.1132 50 15.6748L32.5 5.67476C31.7399 5.23591 30.8777 5.00488 30 5.00488C29.1223 5.00488 28.2601 5.23591 27.5 5.67476L10 15.6748C9.24066 16.1132 8.60995 16.7435 8.17115 17.5027C7.73236 18.2618 7.5009 19.1229 7.5 19.9998V39.9998C7.5009 40.8766 7.73236 41.7377 8.17115 42.4968C8.60995 43.256 9.24066 43.8863 10 44.3248L27.5 54.3248Z",
		stroke: "#0A3C93",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGeneralCargo;
